export default "__VITE_ASSET__DE84e$Ol__"